'use client';

import { motion, AnimatePresence, type TargetAndTransition } from 'framer-motion';
import type { ReactNode } from 'react';
import type { FormTransition } from './formLayout';

interface TransitionVariant {
  initial: TargetAndTransition;
  animate: TargetAndTransition;
  exit: TargetAndTransition;
}

const variants: Record<FormTransition, TransitionVariant> = {
  'slide-up': {
    initial: { opacity: 0, y: 32 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -32 },
  },
  'slide-left': {
    initial: { opacity: 0, x: 32 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -32 },
  },
  'fade': {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
  },
  'none': {
    initial: {},
    animate: {},
    exit: {},
  },
};

interface StepTransitionContainerProps {
  transition?: FormTransition;
  stepKey: string | number;
  children: ReactNode;
  className?: string;
}

export function StepTransitionContainer({
  transition = 'slide-up',
  stepKey,
  children,
  className,
}: StepTransitionContainerProps) {
  const v = variants[transition] || variants['slide-up'];
  const duration = transition === 'none' ? 0 : 0.22;

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={stepKey}
        className={className}
        initial={v.initial}
        animate={v.animate}
        exit={v.exit}
        transition={{ duration, ease: [0.25, 0.1, 0.25, 1] }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
